import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IAlertModalcomponentData {
  title: string;
  message: string;
  confirmText?: string;
}

@Component({
  template: require('./alert-modal.component.html'),
  styles: [require('./alert-modal.component.scss')],
})
export class AlertModalcomponent implements OnInit {
  title: string;
  message: string;
  confirmText: string;

  constructor(public dialogRef: MatDialogRef<AlertModalcomponent>, @Inject(MAT_DIALOG_DATA) public data) {}

  ngOnInit(): void {
    this.title = this.data.title;
    this.message = this.data.message;
    this.confirmText = this.data.confirmText || 'OK';
  }

  onConfirm(): void {
    this.dialogRef.close();
  }
}
